import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import React from 'react';
import Modals from '../../../../modal';
import COMMUNICATION_MODALS from '../components/Dialogs';
import runContextReducer from './runContextReducer';
export var RunContext = React.createContext();
var DEFAULT = {
  currentDataVersion: -1,
  input: '',
  view: {}
};
/**
 * @returns {import('./types').RunState}
 */

var initialLoader = function initialLoader(data) {
  if (!data) return DEFAULT;
  return _objectSpread({}, DEFAULT, data);
};

export var RunContextProvider = function RunContextProvider(_ref) {
  var data = _ref.data,
      children = _ref.children,
      reducers = _ref.reducers;

  var _React$useReducer = React.useReducer(runContextReducer, data, initialLoader),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      runState = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  React.useEffect(function () {
    Modals.register(COMMUNICATION_MODALS);
  }, []);
  var documentRef = React.useRef(null);
  return React.createElement(RunContext.Provider, {
    value: [runState, dispatch, documentRef]
  }, React.createElement(React.Fragment, null, children));
};